import React, { useState, useEffect } from 'react';
import { Card, Button, Stack, Container, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import svgimg from '../../Assets/Sound-Wave.svg';
import { useNavigate } from 'react-router-dom';
import aud from '../../Assets/sample_wave.wav';
import { textToVoiceService } from '../../utils/text-to-voice';
import '../../Component/detailcard.css';
import Wavesample from './waveform';
import { select_lng } from '../../Assets/LangList/text-to-voice_lng_list.js';
import { ApiCall } from '../../apicall';
import fieldsLang from './fieldsLang.json';
import Voiceinput from '../Voiceform';

function Detailcard({ imagesrc, title, disc, currentLang }) {
  const [textLang, setChangeTextLang] = React.useState({});
  const [obj, SetObj] = React.useState({});
  useEffect(() => {
    SetObj(select_lng);
  }, []);
  const onChangeTextLang = val => {
    setChangeTextLang(obj[val]);
  };
  const textToSpeechFun = async () => {
    // TextToSpeech(value, textLang);
    alert('alert');
    const langCode = localStorage.getItem('selectedLang');
    const langVoice = localStorage.getItem('selectedVoice');

    // const { voice, text } = textLang;
    let post = {
      Body: 'Body required',
      language: langCode,
      voice: langVoice,
    };
    let txtAudioBuffer = await textToVoiceService(post);
    // setIsLoading(false);
    console.log(txtAudioBuffer, 'aud received');
    // (txtAudioBuffer);
    let blob = new Blob([txtAudioBuffer], { type: 'audio/wav' });
    setBuf(blob);
    let url = URL.createObjectURL(blob);
    setAudioSrc(url);
    if (txtAudioBuffer.length <= 44) {
      alert('No content available!');
      return false;
    }
  };

  const navigate = useNavigate();
  const [isReadMore, setIsReadMore] = React.useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  const [isReadMoreTitle, setIsReadMoreTitle] = React.useState(true);
  const toggleReadMoreTitle = () => {
    setIsReadMoreTitle(!isReadMoreTitle);
  };

  const sendQueryAsInput = async data => {
    localStorage.setItem('SelectedQueryAsInput', data);
    navigate('/govtofindiascheme/Selected-query');
  };

  return (
    <Container className="Contentcard">
      <Row>
        <Col lg={12} md={12} sm={12} xs={12} className="iconimg">
          <img className="imgcard" src={imagesrc} />
        </Col>
        <Col lg={12} md={12} sm={12} xs={12} className="gapping">
        <p className="discription"><b>
            {isReadMoreTitle && title.length>25 ? title.substring(0, 25) : title}
            <span
              onClick={toggleReadMoreTitle}
              className="read-or-hide"
              style={{ fontSize: '15px' }}>
               {title.length > 25 ? <>
              {isReadMoreTitle ? (
                <>
                  {' '}
                  <b>...{currentLang?fieldsLang[11][currentLang]:''}</b>
                </>
              ) : (
                <>
                  <b>{currentLang?fieldsLang[12][currentLang]:''}</b>
                </>
              )} </> : ""}
            </span>
            </b>
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="discription"dangerouslySetInnerHTML={{__html: disc}}></p>
            {/* {disc} */}
            {/* {isReadMore ? disc.substring(0, 100) + '....' : disc}
            <span onClick={toggleReadMore} className="read-or-hide">
              {isReadMore ? (
                <>
                  {' '}
                  <b>...{currentLang?fieldsLang[11][currentLang]:''}</b>
                </>
              ) : (
                <>
                  <b>{currentLang?fieldsLang[12][currentLang]:''}</b>
                </>
              )}
            </span> */}
          {/* </p> */}
        </Col>
      </Row>
      {/* <Row>
        <Col></Col>
        <Col>
          <Button href="Discription"> View Source {">>"}</Button>
        </Col>
      </Row> */}
      <Row>
        <Wavesample url={aud} disc={disc} langg={localStorage.getItem('selectedLang')}/>
        {/* <button onClick={textToSpeechFun} >View more...</button> */}
        <button
          onClick={() => {
            sendQueryAsInput(title);
          }}>
          {currentLang?fieldsLang[13][currentLang]:''}...
        </button>
      </Row>
    </Container>
  );
}
Detailcard.propTypes = {
  imagesrc: PropTypes.any,
  title: PropTypes.string,
  disc: PropTypes.string,
  currentLang : PropTypes.string
};

export default Detailcard;
